import React, { useState } from 'react'
import { FiChevronDown, FiChevronUp } from 'react-icons/fi'

const Accordion = ({ icon, title, tag, children }) => {

    const [isActive, setIsActive] = useState(false)

    return (
        <div className="accordion">
            <div className="accordion-item">
                <button className={`accordion-header flex justify-between ${isActive ? 'expanded' : 'collapsed'}`} onClick={() => setIsActive(!isActive)}>
                    <div className='accordion-title flex gap-3'>
                        <span className='shrink-0'>{icon}</span>
                        <div className='grow w-8/12'>
                            <h6>{title}</h6>
                            <div>
                            {tag ?<small className='block tag-text whitespace-nowrap overflow-hidden text-ellipsis'>{tag}</small>  : null}
                            </div>
                        </div>
                    </div>
                    <div className='shrink-0 accordion-arrow'>{isActive ? <FiChevronUp  /> : <FiChevronDown  />}</div>
                </button>
                {isActive && <div className="accordion-content">{children}</div>}
            </div>
        </div>
    )
}

export default Accordion